<template>
  <div class="terms">
    <FixedHeader
      :showLoginBtn="true"
      :showSearch="false"
      @clickedLogin="showLogin = !showLogin"
      :showLogin="showLogin"
    >
      <b-button
        class="back-button"
        type="is-text"
        icon-left="arrow-left"
        size="is-medium"
        @click="goTo()"
      ></b-button>
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
    </FixedHeader>
    <div v-if="$i18n.locale === 'en'" class="terms__info">
      <h1>Terms and Conditions</h1>
      <h2>Basis Terms</h2>
      <span>
        1. You may not post violent, nude, partially nude, discriminatory,
        unlawful, infringing, hateful, pornographic or sexually suggestive
        photos or other content via the Service.
      </span>
      <span>
        2. You agree that you will not solicit, collect or use the login
        credentials of other Pinwalls.
      </span>
      <span
        >3. You are responsible for keeping your password secret and
        secure.</span
      >
      <span>
        4. You must not defame, stalk, bully, abuse, harass, threaten,
        impersonate or intimidate people or entities and you must not post
        private or confidential information via the Service, including, without
        limitation, your or any other person's credit card information, social
        security or alternate national identity numbers, non-public phone
        numbers or non-public email addresses.
      </span>
      <span>
        5. You may not use the Service for any illegal or unauthorized purpose.
        You agree to comply with all laws, rules and regulations (for example,
        federal, state, local and provincial) applicable to your use of the
        Service and your Content (defined below), including but not limited to,
        copyright laws.
      </span>
      <span>
        6. You are solely responsible for your conduct and any data, text,
        files, information, usernames, images, graphics, photos, profiles, audio
        and video clips, sounds, musical works, works of authorship,
        applications, links and other content or materials (collectively,
        "Content") that you submit, post or display on or via the Service.
      </span>
      <span>
        7. You must not interfere or disrupt the Service or servers or networks
        connected to the Service, including by transmitting any worms, viruses,
        spyware, malware or any other code of a destructive or disruptive
        nature. You may not inject content or code or otherwise alter or
        interfere with the way any Pinwall page is rendered or displayed in a
        user's browser or device.
      </span>
      <span>
        8. You must not create accounts with the Service through unauthorized
        means, including but not limited to, by using an automated device,
        script, bot, spider, crawler or scraper
      </span>
      <span>
        9.You must not attempt to restrict another user from using or enjoying
        the Service and you must not encourage or facilitate violations of these
        Terms of Use or any other Pinwall terms.
      </span>
      <h2>General Conditions</h2>
      <span>
        We reserve the right, in our sole discretion, to change these Terms of
        Use ("Updated Terms") from time to time. Unless we make a change for
        legal or administrative reasons, we will provide reasonable advance
        notice before the Updated Terms become effective. You agree that we may
        notify you of the Updated Terms by posting them on the Service, and that
        your use of the Service after the effective date of the Updated Terms
        (or engaging in such other conduct as we may reasonably specify)
        constitutes your agreement to the Updated Terms. Therefore, you should
        review these Terms of Use and any Updated Terms before using the
        Service. The Updated Terms will be effective as of the time of posting,
        or such later date as may be specified in the Updated Terms, and will
        apply to your use of the Service from that point forward. These Terms of
        Use will govern any disputes arising before the effective date of the
        Updated Terms.
      </span>
      <span>
        We reserve the right to refuse access to the Service to anyone for any
        reason at any time.
      </span>
      <span>
        We may, but have no obligation to, remove, edit, block, and/or monitor
        Content or accounts containing Content that we determine in our sole
        discretion violates these Terms of Use.
      </span>
      <span>
        You are solely responsible for your interaction with other users of the
        Service, whether online or offline. You agree that Pinwall is not
        responsible or liable for the conduct of any user. Pinwall reserves the
        right, but has no obligation, to monitor or become involved in disputes
        between you and other users. Exercise common sense and your best
        judgment when interacting with others, including when you submit or post
        Content or any personal or other information.
      </span>
      <span>
        We prohibit crawling, scraping, caching or otherwise accessing any
        content on the Service via automated means, including but not limited
        to, user profiles and photos (except as may be the result of standard
        search engine protocols or technologies used by a search engine with
        Pinwall's express consent).
      </span>
      <h2>Rights</h2>
      <span>
        Pinwall does not claim ownership of any Content that you post on or
        through the Service. You can choose who can view your Content and
        activities, including your photos.
      </span>
      <h2>Disclaimer of Warranties</h2>
      <span>
        PINWALL DO NOT REPRESENT OR WARRANT THAT THE SERVICE WILL BE ERROR-FREE
        OR UNINTERRUPTED; THAT DEFECTS WILL BE CORRECTED; OR THAT THE SERVICE OR
        THE SERVER THAT MAKES THE SERVICE AVAILABLE IS FREE FROM ANY HARMFUL
        COMPONENTS, INCLUDING, WITHOUT LIMITATION, VIRUSES. PINWALL DO NOT MAKE
        ANY REPRESENTATIONS OR WARRANTIES THAT THE INFORMATION (INCLUDING ANY
        INSTRUCTIONS) ON THE SERVICE IS ACCURATE, COMPLETE, OR USEFUL. YOU
        ACKNOWLEDGE THAT YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK. PINWALL
        DO NOT WARRANT THAT YOUR USE OF THE SERVICE IS LAWFUL IN ANY PARTICULAR
        JURISDICTION, AND PINWALL SPECIFICALLY DISCLAIM SUCH WARRANTIES. SOME
        JURISDICTIONS LIMIT OR DO NOT ALLOW THE DISCLAIMER OF IMPLIED OR OTHER
        WARRANTIES SO THE ABOVE DISCLAIMER MAY NOT APPLY TO YOU TO THE EXTENT
        SUCH JURISDICTION'S LAW IS APPLICABLE TO YOU AND THESE TERMS OF USE.
      </span>
      <span>
        BY ACCESSING OR USING THE SERVICE YOU REPRESENT AND WARRANT THAT YOUR
        ACTIVITIES ARE LAWFUL IN EVERY JURISDICTION WHERE YOU ACCESS OR USE THE
        SERVICE.
      </span>
      <span>
        PINWALL DO NOT ENDORSE CONTENT AND SPECIFICALLY DISCLAIM ANY
        RESPONSIBILITY OR LIABILITY TO ANY PERSON OR ENTITY FOR ANY LOSS, DAMAGE
        (WHETHER ACTUAL, CONSEQUENTIAL, PUNITIVE OR OTHERWISE), INJURY, CLAIM,
        LIABILITY OR OTHER CAUSE OF ANY KIND OR CHARACTER BASED UPON OR
        RESULTING FROM ANY CONTENT.
      </span>
    </div>
    <div v-if="$i18n.locale === 'de'" class="terms__info">
      <h1>Allgemeine Geschäftsbedingungen</h1>
      <h2>Basisbedingungen</h2>
      <span>
        1. Sie dürfen keine gewalttätigen, nackten, teilweise nackten,
        diskriminierenden, ungesetzliche, verletzende, hasserfüllte,
        pornografische oder sexuell anzügliche Fotos oder andere Inhalte über
        den Dienst veröffentlichen.
      </span>
      <span>
        2. Sie stimmen zu, dass Sie die Anmeldedaten anderer Pinwalls nicht
        anfordern, sammeln oder verwenden werden.
      </span>
      <span
        >3. Sie sind dafür verantwortlich, Ihr Passwort geheim zu halten und
        sicher zu halten.</span
      >
      <span>
        4. Sie dürfen keine Personen oder Organisationen diffamieren, stalken,
        schikanieren, missbrauchen, belästigen, bedrohen, sich als solche
        ausgeben oder einschüchtern, und Sie dürfen keine privaten oder
        vertraulichen Informationen über den Dienst veröffentlichen,
        einschließlich, aber nicht beschränkt auf Ihre oder die
        Kreditkarteninformationen einer anderen Person,
        Sozialversicherungsnummern oder andere nationale Identitätsnummern,
        nicht öffentliche Telefonnummern oder nicht öffentliche E-Mail-Adressen.
      </span>
      <span>
        5. Sie dürfen den Dienst nicht für illegale oder unbefugte Zwecke
        nutzen. Sie verpflichten sich, alle Gesetze, Regeln und Vorschriften (z.
        B. auf Bundes-, Landes-, Kommunal- und Provinzebene) einzuhalten, die
        für Ihre Nutzung des Dienstes und Ihre Inhalte (wie unten definiert)
        gelten, einschließlich, aber nicht beschränkt auf Urheberrechtsgesetze.
      </span>
      <span>
        6. Sie sind allein verantwortlich für Ihr Verhalten und alle Daten,
        Texte, Dateien, Informationen, Benutzernamen, Bilder, Grafiken, Fotos,
        Profile, Audio- und Audio- und Videoclips, Töne, musikalische Werke,
        Werke der Urheberschaft, Anwendungen, Links und andere Inhalte oder
        Materialien (zusammenfassend, "Inhalte"), die Sie im oder über den
        Dienst einreichen, veröffentlichen oder anzeigen.</span
      >
      <span>
        7. Sie dürfen den Dienst oder die mit dem Dienst verbundenen Server oder
        Netzwerke nicht stören oder unterbrechen, auch nicht durch die
        Übertragung von Würmern, Viren, Spyware, Malware oder anderen Codes mit
        zerstörerischer oder störender Wirkung. Sie dürfen keine Inhalte oder
        Codes einfügen oder die Art und Weise, wie eine Pinwall-Seite im Browser
        oder auf dem Gerät eines Nutzers dargestellt wird, anderweitig verändern
        oder stören.
      </span>
      <span>
        8. Sie dürfen keine Konten mit dem Dienst durch unbefugte Mittel
        erstellen Mitteln erstellen, einschließlich, aber nicht beschränkt auf,
        die Verwendung eines automatisierten Geräts, Skript, Bot, Spider,
        Crawler oder Scraper
      </span>
      <span>
        9 Sie dürfen nicht versuchen, einen anderen Nutzer an der Nutzung oder
        am Genuss des Dienstes zu hindern. Sie dürfen nicht versuchen, einen
        anderen Nutzer an der Nutzung des Dienstes zu hindern, und Sie dürfen
        keine Verstöße gegen diese Nutzungsbedingungen oder sonstiger
        Pinwall-Bedingungen.
      </span>
      <h2>Allgemeine Bedingungen</h2>
      <span>
        Wir behalten uns das Recht vor, diese Nutzungsbedingungen nach eigenem
        Ermessen zu ändern ("Aktualisierte Bedingungen") von Zeit zu Zeit zu
        ändern. Sofern wir eine Änderung nicht aus aus rechtlichen oder
        administrativen Gründen vornehmen, werden wir bevor die aktualisierten
        Bedingungen in Kraft treten. Sie erklären sich damit einverstanden, dass
        wir Sie über die aktualisierten Bedingungen informieren, indem wir sie
        im Dienst veröffentlichen, und dass Ihre Nutzung des Dienstes nach dem
        Datum des Inkrafttretens der aktualisierten Bedingungen (oder ein
        anderes Verhalten, das wir in angemessener Weise festlegen können) Ihre
        Zustimmung zu den aktualisierten Bedingungen darstellt. Daher sollten
        Sie diese Nutzungsbedingungen und alle aktualisierten Bedingungen
        durchlesen, bevor Sie den Dienstes. Die aktualisierten Bedingungen
        gelten ab dem Zeitpunkt der Veröffentlichung, oder einem späteren Datum,
        das in den aktualisierten Bedingungen angegeben ist, und und gelten für
        Ihre Nutzung des Dienstes von diesem Zeitpunkt an. Diese
        Nutzungsbedingungen Nutzungsbedingungen gelten für alle Streitigkeiten,
        die vor dem Datum des Inkrafttretens der Aktualisierten Bedingungen.
      </span>
      <span>
        Wir behalten uns das Recht vor, jeder Person den Zugang zum Dienst aus
        beliebigen Gründen Grund jederzeit zu verweigern.
      </span>
      <span>
        Wir können, sind aber nicht verpflichtet, folgende Inhalte zu entfernen,
        zu bearbeiten, zu sperren und/oder zu überwachen Inhalte oder Konten mit
        Inhalten, die wir nach eigenem Ermessen als Ermessen gegen diese
        Nutzungsbedingungen verstoßen.
      </span>
      <span>
        Sie sind allein verantwortlich für Ihre Interaktion mit anderen Nutzern
        des Service, ob online oder offline. Sie stimmen zu, dass Pinwall nicht
        verantwortlich oder haftbar für das Verhalten eines Benutzers ist.
        Pinwall behält sich das Recht vor, ist aber nicht verpflichtet,
        Streitigkeiten zwischen Ihnen und anderen zwischen Ihnen und anderen
        Nutzern. Nutzen Sie Ihren gesunden Menschenverstand und Ihr bestes
        Urteilsvermögen, wenn Sie mit anderen interagieren, auch wenn Sie
        Inhalte oder persönliche oder andere Informationen.
      </span>
      <span>
        Wir verbieten das Crawling, Scraping, Caching oder den anderweitigen
        Zugriff auf jegliche Inhalte des Dienstes mit automatisierten Mitteln,
        einschließlich, aber nicht beschränkt auf Benutzerprofilen und Fotos
        (außer wenn dies das Ergebnis von Standard Suchmaschinenprotokollen oder
        Technologien, die von einer Suchmaschine mit Pinwalls ausdrücklicher
        Zustimmung).
      </span>
      <h2>Rechte</h2>
      <span>
        Pinwall erhebt keinen Anspruch auf das Eigentum an Inhalten, die Sie auf
        oder durch den Service veröffentlichen. Sie können wählen, wer Ihre
        Inhalte und Aktivitäten Aktivitäten, einschließlich Ihrer Fotos, sehen
        kann.
      </span>
      <h2>Ausschluss von Garantien</h2>
      <span>
        PINWALL SICHERT NICHT ZU ODER GARANTIERT NICHT, DASS DER DIENST
        FEHLERFREI IST ODER UNUNTERBROCHEN IST; DASS FEHLER KORRIGIERT WERDEN;
        ODER DASS DER DIENST ODER DER DER SERVER, DER DEN DIENST ZUR VERFÜGUNG
        STELLT, FREI VON SCHÄDLICHEN KOMPONENTEN, EINSCHLIESSLICH, OHNE
        EINSCHRÄNKUNG, VIREN. PINWALL GIBT KEINE KEINE ZUSICHERUNGEN ODER
        GARANTIEN, DASS DIE INFORMATIONEN (EINSCHLIESSLICH ALLER ANLEITUNGEN)
        DES DIENSTES GENAU, VOLLSTÄNDIG ODER NÜTZLICH SIND. SIE ERKENNEN AN,
        DASS DIE NUTZUNG DES DIENSTES AUF IHR EIGENES RISIKO ERFOLGT. PINWALL
        GARANTIERT NICHT, DASS IHRE NUTZUNG DES DIENSTES IN EINEM BESTIMMTEN
        LAND RECHTMÄSSIG IST. UND PINWALL LEHNT SOLCHE GARANTIEN AUSDRÜCKLICH
        AB. EINIGE GERICHTSBARKEITEN SCHRÄNKEN DEN AUSSCHLUSS VON
        STILLSCHWEIGENDEN ODER ANDEREN GEWÄHRLEISTUNGEN, SO DASS DER OBIGE
        HAFTUNGSAUSSCHLUSS MÖGLICHERWEISE NICHT AUF SIE ZUTRIFFT, SOWEIT DIE
        GESETZE EINER SOLCHEN GERICHTSBARKEIT AUF SIE UND DIESE
        NUTZUNGSBEDINGUNGEN ANWENDBAR SIND.
      </span>
      <span>
        MIT DEM ZUGRIFF AUF ODER DER NUTZUNG DES DIENSTES ERKLÄREN UND
        GARANTIEREN SIE, DASS IHRE AKTIVITÄTEN IN JEDER GERICHTSBARKEIT, IN DER
        SIE AUF DEN DIENST ZUGREIFEN ODER IHN NUTZEN, RECHTMÄSSIG SIND. SERVICE
        NUTZEN.
      </span>
      <span>
        PINWALL BILLIGT DEN INHALT NICHT UND LEHNT AUSDRÜCKLICH JEGLICHE
        VERANTWORTUNG ODER HAFTUNG GEGENÜBER NATÜRLICHEN ODER JURISTISCHEN
        PERSONEN FÜR JEGLICHE VERLUSTE, SCHÄDEN (OB TATSÄCHLICH, ALS FOLGE, MIT
        STRAFCHARAKTER ODER ANDERWEITIG), VERLETZUNGEN, ANSPRÜCHE, ANSPRÜCHE,
        HAFTUNG ODER ANDERE GRÜNDE JEGLICHER ART UND BESCHAFFENHEIT, DIE AUF DIE
        SICH AUS EINEM INHALT ERGEBEN.
      </span>
    </div>
    <Footer />
  </div>
</template>

<script>
import FixedHeader from "../components/FixedHeader";
import Footer from "@/components/Footer";
import { goTo } from "../mixins/goTo.js";
import { mapGetters } from "vuex";

export default {
  name: "terms_en",
  data: () => {
    return {
      showLogin: false
    };
  },
  computed: {
    ...mapGetters(["darkMode"])
  },
  components: {
    FixedHeader,
    Footer
  },
  mixins: [goTo],
  mounted: function() {
    window.scrollTo(0, 0);
  }
};
</script>

<style></style>
